import { useEffect, useState } from 'react';
import _ from 'lodash';

import { useHistory } from 'react-router-dom';

export default function useCheckProduct(prop: any) {
  const [show, setShow] = useState(false);
  const { location: { pathname } } = useHistory();

  useEffect(() => {
    if (_.isEmpty(prop?.showOptions)) {
      setShow(false);
    } else if (prop.showOptions?.product === 'All' || pathname.includes(prop.showOptions?.product.toLowerCase())) {
      setShow(true);
    }
  }, [prop?.showOptions, pathname]);

  return show;
}
